import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { history, getQueryParams, updateQueryParam } from '../routing/history';
import LanguageContext from './LanguageContext';

const hostname = window.location.hostname;
const cookieDomain = hostname.indexOf('localhost') !== -1 ? 'localhost' : 'creditinfo.is';

const setCookie = lang => {
  Cookies.set('userCulture', 'c=is-IS|uic=' + lang, {
    expires: 365,
    path: '/',
    domain: cookieDomain
  });
};

const swapLangQueryParam = lang => {
  const searchParams = getQueryParams();
  if (searchParams.lang) {
    updateQueryParam('lang', lang);
  }
};

let storedLang = 'is';
let langCookie = Cookies.get('userCulture', { domain: cookieDomain });
const { lang } = getQueryParams();

if (!lang && langCookie !== undefined) {
  var idx = langCookie.indexOf('uic=');
  if (idx !== -1) {
    storedLang = langCookie.substr(idx + 4, 2);
  } else {
    idx = langCookie.indexOf('uic%3D');
    if (idx !== -1) {
      storedLang = langCookie.substr(idx + 6, 2);
    }
  }
} else {
  storedLang = lang || storedLang;
  setCookie(storedLang);
}

export default ({ locale = undefined, children, lang = storedLang }) => {
  const [showKey, setShowKey] = useState(false);
  const [language, setLanguage] = useState(lang);
  const [localeObj, setLocaleObj] = useState(locale);

  function updateLanguage(lang) {
    setLanguage(lang);
    setCookie(lang);
    swapLangQueryParam(lang);
  }

  function updateLocaleObj(lang, newLocaleObj) {
    if (locale !== undefined) {
      throw new Error(
        'LanguageProvider is being controlled via the locale prop. ' +
          'updateLocaleForLang should only be used if the component is uncontrolled.'
      );
    } else {
      setLocaleObj(old => ({
        ...old,
        [lang]: newLocaleObj
      }));
    }
  }

  useEffect(() => {
    if (history.location.search.includes('show_locale_string')) {
      setShowKey(true);
    }
  }, []);

  let currentLocale = localeObj;
  // Check if locale is controlled from the outside.
  if (locale !== undefined) {
    currentLocale = locale;
  }

  function t(str, ...args) {
    if (showKey) return str;
    if (!str) return '';

    if (!currentLocale || Object.keys(currentLocale).length === 0 || !currentLocale[lang]) {
      return '';
    }

    let s = currentLocale[language][str];
    if (args.length === 0) return s;
    if (s) {
      for (let i = 0; i < args.length; i++) {
        let index = '{' + i + '}';
        s = s.replace(index, args[i]);
      }
    }
    return s;
  }

  return (
    <LanguageContext.Provider
      value={{
        lang: language,
        t: t,
        setLanguage: updateLanguage,
        updateLocaleForLang: updateLocaleObj,
        locale: currentLocale,
        localeLoaded: currentLocale !== undefined
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export class BackwardsCompatLanguageProvider extends React.Component {
  static childContextTypes = {
    locale: PropTypes.object
  };

  getChildContext() {
    const { locale, lang } = this.props;
    return {
      locale: {
        ...locale[lang],
        currentLang: lang
      }
    };
  }

  render() {
    return this.props.children;
  }
}
export { default as useLocale } from './useLocale';
